module.exports = __webpack_public_path__ + "img/full3-min.6a6df21a.png";